export default __webpack_public_path__ + "static/media/zarph_white_horiz.b5ebb1a5.png";